import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import type { RowClickedEvent } from 'ag-grid-community';
import { defaultColDef, WATCHLISTS_PAGE_SIZE } from './watchlists-table.config';
import { AgGridAngular } from 'ag-grid-angular';
import { customTheme } from 'src/styles/grid-table/grid-table-theme';

@Component({
  selector: 'app-watchlists-table',
  imports: [AgGridAngular],
  template: `
    <ag-grid-angular
      style="width: 100%; height: 100%"
      [columnDefs]="colDefs()"
      [pagination]="pagination()"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="false"
      [enableFilterHandlers]="true"
      [defaultColDef]="defaultColDef()"
      [theme]="theme"
      [tooltipShowDelay]="tooltipShowDelay"
      [rowData]="rowData()"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WatchlistsTableComponent<T> {
  colDefs = input<ColDef[]>([]);
  rowData = input<T[]>([]);
  pagination = input<boolean>(true);

  rowClicked = output<RowClickedEvent<T>>();
  gridReady = output<GridReadyEvent>();

  defaultColDef = input(defaultColDef);
  pageSize = WATCHLISTS_PAGE_SIZE;
  theme = customTheme;
  tooltipShowDelay = 500;

  gridApi!: GridApi;

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridReady.emit(params);
  }

  onRowClicked(event: RowClickedEvent<T>): void {
    this.rowClicked.emit(event);
  }
}
